import { WorkshopRegistrationConstants } from './workshopRegistrationConstants';

/**
 * Pure mappers and transformers for Workshop Registration.
 * 0 React hooks, 0 JSX, 100% pure functions.
 */

/**
 * Returns default form values for Workshop Registration.
 */
export const getWorkshopRegistrationDefaultValues = () => ({
    [WorkshopRegistrationConstants.FULL_NAME]: '',
    [WorkshopRegistrationConstants.EMAIL]: '',
    [WorkshopRegistrationConstants.IDENTITY_DOCUMENT]: null,
});

/**
 * Builds multipart/form-data payload for backend registration endpoint.
 *
 * @param {object} data - Form values from react-hook-form
 * @returns {FormData}
 */
export const buildWorkshopRegistrationFormData = (data) => {
    const formData = new FormData();

    const fullName = (data[WorkshopRegistrationConstants.FULL_NAME] || '').trim();
    const email = (data[WorkshopRegistrationConstants.EMAIL] || '').trim();

    formData.append(WorkshopRegistrationConstants.FULL_NAME, fullName);
    formData.append(WorkshopRegistrationConstants.EMAIL, email);

    // Extract File object from FormFileUpload structure
    const identityValue = data[WorkshopRegistrationConstants.IDENTITY_DOCUMENT];
    let identityFile = null;

    if (Array.isArray(identityValue) && identityValue.length > 0) {
        identityFile = identityValue[0].file || identityValue[0];
    } else if (identityValue?.file) {
        identityFile = identityValue.file;
    } else if (identityValue instanceof File) {
        identityFile = identityValue;
    }

    if (identityFile instanceof File) {
        formData.append(WorkshopRegistrationConstants.IDENTITY_DOCUMENT, identityFile);
    }

    return formData;
};
